import { prop, compose } from 'ramda';

import connect from 'app/libs/connect';
import renderIf from 'app/enhancers/renderIf';
import wrapIn from 'app/enhancers/wrapIn';
import HelpCenter from 'app/features/helpCenter/components/HelpCenter';
import BlockWrapper from 'app/features/success/components/BlockWrapper';
import { isVisible, faq } from 'app/features/success/helpCenterBlock/selectors';

const HelpCenterBlock = compose(
  connect({ isVisible, faq }),
  renderIf(prop('isVisible')),
  wrapIn(BlockWrapper),
)(HelpCenter);

export default HelpCenterBlock;
